<template>
    <!-- <w-app> -->

    <w-flex row wrap class="text-center  ">

        <div class="xs4 pa1 ">
            <w-card content-class="pa1" shadow title="Search" title-class="primary-dark1--bg">
                <w-form @submit.prevent="search()">
                    <w-input class="mb1" label="Model Search" v-model="newSearch" name="newSearch"
                        inner-icon-left="wi-search" label-position="inside" outline="outline"></w-input>

                    <w-button bg-color="warning" type="submit">Search</w-button>
                </w-form>
                <w-form @submit.prevent="searchPN()">
                    <w-input class="mb1" label="Spare Part Search" v-model="SparePartSearch" name="newSearch"
                        inner-icon-left="wi-search" label-position="inside" outline="outline"></w-input>
                    <w-button bg-color="warning" type="submit">Search</w-button>
                </w-form>
                <template #actions>
                    <div class="spacer"></div>
                </template>
            </w-card>
            <!-- <button @click="d8ToMan()">D8</button> -->
        </div>
        <div class="xs8 pa1">
            <w-card content-class="pa0" shadow title=" Results" title-class="primary-dark1--bg">
                <w-accordion content-class="pa1" v-if="Devices.items.length > 0 || Devices.loading" :items="1"
                    v-model="Devices.accordion">
                    <template #item-title>Models {{
                        Devices.items.length
                    }}</template>

                    <template #item-content>

                        <w-table content-class="mb1" :headers="Devices.headers" :items="Devices.items"
                            :loading="Devices.loading" :mobile-breakpoint="600" :selectable-rows="Devices.selectableRows"
                            :sort="Devices.sort" select-row="select-row" @row-select="getALLParts([$event.item])">
                            <!-- @row-select="selectionInfo = $event" -->
                            <!-- @row-select="searchDeviceArticle(filterByCodeOrType(Devices.items,$event.item))" -->
                            <!-- @row-select="searchDeviceArticle([$event.item,Devices.items.filter(it=>{if (it.suppliers !== $event.item.suppliers && (it.Type == $event.item.Type.trim() && it.Identnummer == $event.item.Identnummer)) return it})])" -->

                            <template #no-data>👌 There is no data! 👌</template>
                        </w-table>
                        <!-- <w-button class="mt1" bg-color="warning" @click="getALLParts(selectionInfo.selectedRows)">Search
                            Selected</w-button> -->
                    </template>
                </w-accordion>

                <w-accordion content-class="pa1" v-if="PartsTable.items.length > 0 || PartsTable.loading" :items="1"
                    v-model="PartsTable.accordion">
                    <template #item-title>Parts {{ PartsTable.items.length }}</template>

                    <template #item-content>

                        <w-flex justify-center class="pa1">
                            <w-input class="xs9 pa1" inner-icon-left="wi-search" label-position="inside" outline="outline"
                                label="Part Search " v-model="PartSearch" />
                            <!-- <w-input class="xs3 pa1" inner-icon-left="wi-search" label-position="inside"
                                outline="outline" label="Pos No " v-model="PosLookup" /> -->
                            <w-button icon="mdi mdi-filter" text lg class="ml3" bg-color="warning" outline
                                @click="FilterButton()"></w-button>
                        </w-flex>
                        <w-table resizable-columns :headers="PartsTable.headers" :items="PartsTable.items"
                            :mobile-breakpoint="600" :loading="PartsTable.loading" :sort="PartsTable.sort"
                            :filter="PartsTable.filter" :selectable-rows="PartsTable.selectableRows"
                            @row-select="getPartDetails($event.item)">
                            <template #no-data>👌 There is no data! 👌</template>
                            <template #item="{ item, index, select, classes }">
                                <tr @click="select">
                                    <td v-for="(header, i) in PartsTable.headers" :key="i" :style="item.style">
                                        <img v-if="header.label == 'ID'" :src="item.imageThumbnail"
                                            style=" padding: 3px 3px 0px 3px;" />
                                        {{ item[header.key] || '' }}
                                        <div
                                            v-if="header.label == 'Add To Cart' && item.alternative != undefined ? item.alternative.startsWith('C') : false">
                                            <SvgIcon name="Cart" @click="addPartToShoppingCart(item)"></SvgIcon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <!-- <template #item-cell="{ item, label, header }">
                                <div v-if="header.label == 'ID'">
                                    <img :src="item.imageThumbnail" />

                                </div>

                                <div :style="item.style">{{ label }}</div>
                            </template> -->
                        </w-table>
                    </template>
                </w-accordion>

            </w-card>
        </div>


    </w-flex>
    <!-- </w-app> -->
</template>
<script>

import router from "../router"
import { ref } from "vue";
import { useSearchStore } from '../store/search'
import ConnectView from "./ConnectView.vue";
import TitleBarView from "../views/TitleBarView.vue"
import { getAltParts, providersToModelList, providersToPartsList, getPartFromDNumber } from "../components/Wrapper";
import { usePartStore } from '../store/part'
import SvgIcon from '../components/SvgIcon.vue';
import { d8ToMan } from '../components/d8toman'
import { clearGlobalCaches } from "pdfjs-dist/build/pdf.worker";

export default {
    name: "Search",
    components: {
        TitleBarView,
        ConnectView, SvgIcon
    },




    setup() {



        const newSearch = ref("");
        const PartSearch = ref("");

        const SparePartSearch = ref("");
        const PosLookup = ref("");
        let Devices = ref({
            headers: [
                { label: "Supplier", key: `supplierName`, align: "center" },
                { label: "Brand	", key: "brand", align: "center" },
                { label: "Family", key: "type", align: "center" },

                { label: "Model", key: "model", align: "center" },
                { label: "Code", key: "variant", align: "center" },
                { label: "Number Of Parts", key: "totalResults", align: "center" }
            ],
            items: [],
            loading: false,
            selectableRows: true,
            // sort: "-model"
            sort: ""
        });
        let files = ref({});
        let lookingat = ref({
            headers: [
                { label: "Supplier", key: `supplierName`, align: "center" },
                { label: "Brand	", key: "brand", align: "center" },
                { label: "Family", key: "type", align: "center" },

                { label: "Model", key: "model", align: "center" },
                { label: "Code", key: "variant", align: "center" },
                { label: "Number Of Parts", key: "totalResults", align: "center" }
            ],
            items: []
        });

        let PartsTable = ref({
            headers: [
                { label: "ID", key: "partNumber", align: "center" },
                { label: "Supplier", key: "supplierName", align: "center" },
                { label: "Part Alternative", key: "alternative", align: "center" },

                { label: "Brand/Family", key: "brand", align: "center" },
                // { label: "P/N", key: "partNumber", align: "center" },
                { label: "Man Code", key: "manufactureCode", align: "center" },
                { label: "Description", key: "description", align: "center" },
                // { label: " Price ", key: "fullPrice", align: "center" },
                { label: "Add To Cart", key: "cart", align: "center" },

                { label: "Price ", key: "unitPrice", align: "center" },
                // { label: "In Stock", key: "inStock", align: "center" },
                // { label: "Special Order", key: "specialOrder", align: "center" },
                // { label: "Obsolete", key: "Obsolete", align: "center" },
                // { label: "Alternative", key: "Alternative", align: "center" },
                // { label: "Pos No", key: "positionNumber", align: "center" }
            ],
            items: [],
            selectableRows: true,
            selectionInfo: {},
            loading: false,
            accordion: [false],
            sort: "+description",
            filter: item =>
                item.description.toUpperCase().includes(
                    PartSearch.value.toUpperCase()
                )
                    &&

                    item.positionNumber ? item.positionNumber.includes(PosLookup.value.toUpperCase()) : false

        });


        function search() {
            Devices.value.items = [];
            files.value = [];
            lookingat.value.items = []
            PartsTable.value.items = [];
            PartsTable.value.accordion = [false];
            Devices.value.accordion = [true];
            SparePartSearch.value = ""
            Devices.value.loading = true;
            if (newSearch.value == "") {
                router.push({ name: 'search' })
                Devices.value.loading = false;
                return
            }
            providersToModelList(newSearch.value).then(models => {
                Devices.value.items = sortByMultipleProperties(models.flatMap(el => el), 'variant asc', 'model asc', 'totalResults desc')
                Devices.value.loading = false;
            })
            // useSearchStore().setSearch(newSearch.value);
            // router.push({ name: "results" });
        }
        function searchPN() {
            Devices.value.items = [];
            lookingat.value.items = [];
            files.value = [];
            Devices.value.accordion = [false];
            PartsTable.value.items = [];
            PartsTable.value.accordion = [true];
            newSearch.value = ""
            PartsTable.value.loading = true;
            if (SparePartSearch.value.indexOf(' ') >= 0) {
                SparePartSearch.value = SparePartSearch.value.trim()
                console.log(SparePartSearch.value);
            }
            if (SparePartSearch.value == "" || SparePartSearch.value.indexOf(' ') >= 0 || SparePartSearch.value.length < 4
            ) {
                console.log(SparePartSearch.value.indexOf(' ') >= 0);
                PartsTable.value.loading = false;
                alert(
                    " Please Only Search For PartNumbers")
                return
            }

            if (SparePartSearch.value.toUpperCase().trim().startsWith("D1")) {
                getPartFromDNumber(SparePartSearch.value.toUpperCase().trim()).then(altPart => {
                    // alert(`D Number Lookup For ${altPart}`)
                    if (altPart != "No C or D Number") {
                        providersToPartsList(altPart).then(listOfParts => {
                            PartsTable.value.items = listOfParts.flatMap(el => el)
                            PartsTable.value.loading = false;
                            const altPromise = Promise.all(sortTable(PartsTable.value.items, PartsTable.value.sort != undefined ? PartsTable.value.sort : ["+description"]).map((async (part, index) => {
                                //get size of table - size of whats shown instead of 11 

                                // console.log("Items Per Page", Math.round(tableOuterHeight.value.clientHeight / 80));
                                if (index < 12) {
                                    // console.log(index, part);
                                    part.alternative = await getAltParts(part)
                                    if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                                    if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                                    return part
                                }
                                else { return part }

                            })

                            ))
                            altPromise.then(parts => { PartsTable.value.items = parts })

                        });
                    } else {
                        PartsTable.value.loading = false;
                    }
                })


            } else {
                providersToPartsList(SparePartSearch.value.trim()).then(listOfParts => {
                    PartsTable.value.items = listOfParts.flatMap(el => el)
                    PartsTable.value.loading = false;
                    const altPromise = Promise.all(sortTable(PartsTable.value.items, PartsTable.value.sort != undefined ? PartsTable.value.sort : ["+description"]).map((async (part, index) => {
                        //get size of table - size of whats shown instead of 11 

                        // console.log("Items Per Page", Math.round(tableOuterHeight.value.clientHeight / 80));
                        if (index < 12) {
                            // console.log(index, part);
                            part.alternative = await getAltParts(part)
                            if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                            if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                            return part
                        }
                        else { return part }

                    })

                    ))
                    altPromise.then(parts => { PartsTable.value.items = parts })

                });
            }
            // useSearchStore().setSearch(SparePartSearch.value);
            // router.push({ name: "results" });
        }
        const sortTable = (arr, properties) => {
            // console.log(properties);
            return arr.sort((a, b) => {
                const [order, prop] = [properties[0].substr(0, 1), properties[0].substr(1)]

                if (a[prop] > b[prop]) {
                    return order == '+' ? 1 : -1;
                }
                if (a[prop] < b[prop]) {
                    return order == '+' ? -1 : 1;
                }
                return 0
            })
        }
        const sortByMultipleProperties = (arr, ...properties) => {
            return arr.sort((a, b) => {
                for (let i = 0; i < properties.length; i++) {
                    const [prop, order] = properties[i].split(' ');
                    if (a[prop] > b[prop]) {
                        return order === 'asc' ? 1 : -1;
                    }
                    if (a[prop] < b[prop]) {
                        return order === 'asc' ? -1 : 1;
                    }
                    // If values are equal, compare next criterion
                    continue;
                }
                // If all criteria are equal, return 0
                return 0;
            });
        }
        function getPartDetails(part) {
            console.log("Getting Part", part);
            usePartStore().setPart(part)

            router.push({ name: 'Part', params: { id: part.id } })
        }

        function getALLParts(data) {
            // console.log(data);
            useSearchStore().setSearch(data)

            router.push({ name: 'models' })
        }

        return {
            search,
            searchPN,
            newSearch,
            SparePartSearch,
            Devices,
            PartsTable,
            PartSearch,
            PosLookup,
            getPartDetails,
            getALLParts,
            window: {
                width: 0,
                height: 0,
                popStateDetected: false
            },
            d8ToMan

        };
    },

}





</script>
<style scoped>
/* .w-app .primary-dark1--bg {
    background-color: #001f59;
}

.w-app .primary-dark3--bg {
    color: #fff;
} */



div.w-table-wrap {

    height: 65vh;

}

div.w-card__content {
    padding: 55px;
    flex-grow: 1;
}


.w-accordion {

    flex-grow: 1;
}

.cards {
    padding: 0;
}
</style> 